import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledIntensityIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M21 20V5.41421C21 4.52331 19.9229 4.07714 19.2929 4.70711L4.7071 19.2929C4.07714 19.9229 4.52331 21 5.41421 21H20C20.5523 21 21 20.5523 21 20Z",
			fill: "#E0E0E0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.70711 19.2929L15 9V21H5.41421C4.52331 21 4.07714 19.9229 4.70711 19.2929Z",
			fill: "#E0E0E0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.70711 19.2929L9 15V21H5.41421C4.52331 21 4.07714 19.9229 4.70711 19.2929Z",
			fill: "#E0E0E0"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledIntensityIcon);
const Memo = memo(ForwardRef);
export default Memo;
